import { render, staticRenderFns } from "./BallStage.vue?vue&type=template&id=514a962f&scoped=true"
import script from "./BallStage.vue?vue&type=script&lang=js"
export * from "./BallStage.vue?vue&type=script&lang=js"
import style0 from "./BallStage.vue?vue&type=style&index=0&id=514a962f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a962f",
  null
  
)

export default component.exports